// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1_zcZ","requiredAsterisk":"Info_requiredAsterisk__3f2q4"};